import * as constants from './constants';

export const initialState = {
  loading: false,
  data: [],
  error: null,
};

export const historyReducer = (state = initialState, action) => {
  switch (action.type) {
  case constants.GET_HISTORY:
    return { ...state, loading: true };
  case constants.GET_HISTORY_SUCCESS: {
    return { ...state, loading: false, data: action.payload };
  }
  case constants.GET_HISTORY_ERROR:
    return { ...state, loading: false, error: action.payload };
  default:
    return state;
  }
};
